'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var formButtons = (0, _reactIntl.defineMessages)({
    login: {
        'id': 'formButtons.login',
        'defaultMessage': 'Login'
    },
    save: {
        'id': 'formButtons.save',
        'defaultMessage': 'Save'
    },
    saving: {
        'id': 'formButtons.saving',
        'defaultMessage': 'Saving...'
    }
}); /**
    *  formButtons is in MessageDescriptorMap format for react-intl:
    *
    *    type MessageDescriptor = {
    *        id: string,
    *        defaultMessage: string,
    *        description?: string,
    *    };
    *
    *    type MessageDescriptorMap = {[key: string]: MessageDescriptor};)
    */

exports.default = formButtons;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formButtons.js
// module id = 1362
// module chunks = 0